import config from './config';
import { getUserViewModelFromLocalStorage, updateState } from './userApi';
import { debounce } from './helpers';
// eslint-disable-next-line no-unused-vars
import EggService from './services/egg.service';
// eslint-disable-next-line no-unused-vars
import MindBox from './services/mindbox.service';

/**
 * Проверяет есть ли открытый Iframe авторизации
 * @private
 * @return { Boolean }
 */
const checkIfIframeIsExist = () => {
  const url = '//id.rambler.ru/login-20/';
  const iframes = [...document.querySelectorAll('iframe')];
  let found = false;
  for (let i = 0; i <= iframes.length - 1; i++) {
    const iframe = iframes[0];
    if (iframe) {
      const src = String(iframe.getAttribute('src'));
      found = src && src.includes(url);
      if (found) {
        break;
      }
    }
  }
  return found;
};

/**
 * Открывает IFrame с формой авторизации
 * @public
 */
export const openIframeAuth = debounce(() => {
  // Проверим что нету открытых iframe
  if (checkIfIframeIsExist()) return;
  // Скрипт исполняется на мобилке?
  const isMobile = window.is_mobile;
  const options = {
    // Редирект url - как указано в документации
    path: config.redirectTo,
    // Идентификатор проекта
    rname: config.rname,
    // Выбранная тема для форм авторизации
    theme: isMobile ?
      config.themeNames.mobile : config.themeNames.desktop,
  };
  // Вызовем
  // через idHelper Iframe форму
  // для авторизации, (регистрации)
  window.ramblerIdHelper.openAuth(options);
}, 5000);

/**
 * Закрывает окно авторизации с Iframe
 * @public
 */
export const closeIframeAuth = () => {
  window.ramblerIdHelper.closeAuth();
};

/**
 * Выйти отовсюду (daily, ramblerId)
 * @public
 */
export const forceLogout = () => {
  // Вызываем метод для выхода в ID
  window.ramblerIdHelper.logout();
  // Помечаем что был форсированный выход в LS
  localStorage.setItem(config.keys.FORCE_RID, true);
};


/**
 * Разлогиниться на уровне "Daily"
 * @private
 */
const dailyLogout = () => {
  localStorage.removeItem(config.keys.USER_KEY);
};

/**
 * Обновляет данные пользователя
 */
const refreshProfileInfo = () => {
  window.ramblerIdHelper.getProfileInfo({ get_chain_id: 1 }, data => {
    if (data) {
      const { chain_id } = data.info;
      // Запишем токен пользователя в LS
      localStorage.setItem(config.keys.USER_KEY, chain_id.default);
    }
  });
};

/**
 * Сохраняет данные пользователя
 * @private
 * @param rid
 */
const setRidInStorage = rid => {
  if (rid) {
    localStorage.setItem(config.keys.USER_KEY, rid);
    const userViewModel = getUserViewModelFromLocalStorage();
    if (userViewModel) {
      updateState(userViewModel, true);
    } else {
      refreshProfileInfo();
    }
  } else {
    refreshProfileInfo();
  }
};

/**
 * Функция должна вызываться при логине пользователя (registerPossibleOauthLoginCallback)
 * @private
 * @callback
 * @param rid
 */
const getTokenAndAutoLogin = (rid) => {
  // Получаем токен авторизованного пользователя у ID
  window.ramblerIdHelper.getSessionToken(data => {
    if (data && data.token) {
      // Если есть токен, сохраняем его в LocalStorage
      setRidInStorage(rid);
    }
  });
};

/**
 * Функция должна вызываться при logout пользователя
 * @callback
 * @comment debounce - нужен для того, чтобы ослабить багу с зацикливанием post-message
 */
const onLogout = debounce(() => {
  if (localStorage.getItem(config.keys.FORCE_RID)) {
    // Снимаем флаг с LocalStorage
    localStorage.removeItem(config.keys.FORCE_RID);
  } else {
    // Наша функция деоавторизации
    dailyLogout();
  }
  // Удаляем данные пользователя
  localStorage.removeItem(config.keys.USER_DATA_KEY);
  // Обновим стейт пользователя
  updateState(null, false);
}, 5000);

/**
 * Иницилизируем RamblerIDHelper
 * Запрашивает данные пользователя в ramblerID
 * Подписывается на нужные события ID сервиса
 */
const initRamblerIdService = () => {
  const onLogoutCb = () => {
    onLogout();
  };

  // Регистрируем обработчик на событие
  // авторизации пользователя через социальные сети
  window.ramblerIdHelper.registerOnPossibleOauthLoginCallback(() => {
    getTokenAndAutoLogin();
  });

  // Подписываемся на событие авторизации в ramblerID
  window.ramblerIdHelper.addListener('login', () => {
    getTokenAndAutoLogin();
  });

  // Подписываем на выход из ramblerID
  window.ramblerIdHelper.addListener('logout', onLogoutCb);

  // Получаем данные пользователя
  window.ramblerIdHelper.getProfileInfo({ get_chain_id: 1 }, data => {
    const rsdix = localStorage.getItem(config.keys.USER_KEY);
    // Если данных о пользователе нет, значит мы не авторизованы
    if (!data) {
      // Нужно убрать идентификатор пользователя из localStorage
      // И сделать разлогин на уровне "проекта"
      rsdix && dailyLogout();
      // Обновим стейт
      updateState(null, false);
      // Посылаем событие в шину
      window.Daily.ee.emit('notauthorized');
      return;
    }

    // Если данные есть
    const { chain_id } = data.info;

    // Получим идентификатор пользователя
    const _rsidx = chain_id.default;

    // Сделаем идентификатор пользователя глобально доступным для скриптов AdTech
    window.rid = _rsidx;

    // Посылаем событие в шину
    window.Daily.ee.emit('authorized', window.rid);

    // Если сохраненный ключ не равен, тому что сейчас в ramblerID
    if (_rsidx !== rsdix) {
      // Сохраняем токен на нашей стороне в LocalStorage
      getTokenAndAutoLogin(_rsidx);
      // Если токен не изменился
    }
  });
};

// Иницилизируем скрипт когда хелпер будет загрузжен
window.ramblerIdHelper.push(() => {
  // Когда асинхронный SDK RamblerID подгрузился
  // Иницилизируем авторизацию пользователя
  initRamblerIdService();
});




// WEBPACK FOOTER //
// ./daily/assets/id/ramblerId.js